class QuestionSubtype {
  constructor({ id, name, label }) {
    this.id = id
    this.name = name
    this.label = label
  }
}

export default QuestionSubtype
